import { config } from "./defaultConfig";
import { width, height } from "./getWidgetSize";
import { getRowsPos } from "./getRowsPos";
import { formatStepsData } from "./formatData";

export default { width, config, height, getRowsPos, formatStepsData };
